<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<header class="slds-page-header slds-has-bottom-magnet">
  <div class="slds-page-header__row">
    <div class="slds-page-header__col-title">
      <div class="slds-media">
        <div class="slds-media__figure">
          <span class="slds-avatar slds-avatar_medium">
            <img alt="Capture Time" src="/assets/accorto/expenseCapture-100.svg">
          </span>
        </div>
        <div class="slds-media__body">
          <div class="slds-page-header__name">
            <div class="slds-page-header__name-title">
              <h1>
                <span class="slds-page-header__title slds-truncate" i18n id="ex-hdr">Capture Expense</span>
              </h1>
            </div>
          </div>
          <p class="slds-page-header__name-meta" id="ex-name">{{record.name}}</p>
        </div>
      </div>

    </div>
    <div class="slds-page-header__col-actions">
      <div class="slds-page-header__controls">
        <div class="slds-page-header__control">
          <ul class="slds-button-group-list">
            <li *ngIf="showDelete">
              <button (click)="onDelete()"
                      class="slds-button slds-button_neutral"
                      id="ex-delete"
                      title="Delete Time record">
                <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#delete"></use>
                </svg>
                <span i18n>Delete</span>
              </button>
            </li>
            <li>
              <button (click)="onNew()"
                      class="slds-button slds-button_neutral"
                      id="ex-new"
                      title="New Expense record">
                <svg aria-hidden="true" class="slds-button__icon slds-button__icon_left">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#new"></use>
                </svg>
                <span i18n>New</span>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="slds-page-header__row">
    <div class="slds-page-header__col-meta">
      <p class="slds-page-header__meta-text">
        <acc-status-line [error]="error" [message]="message"></acc-status-line>
      </p>
    </div>
  </div>
</header>

<section class="slds-card slds-p-horizontal_small slds-m-top_small slds-is-relative">
  <acc-form #theForm
            (saveRecord)="saveRecord($event)"
            (statusUpdate)="statusUpdate($event)"
            [record]="record"
            [ui]="ui">
  </acc-form>
  <acc-spinner *ngIf="busy"></acc-spinner>
</section>
